/* angular:styles/component:css;fbe718564a2a4d68b82da7217bf69a50f7f2e57356595afb2b974a717629d74b;/Users/stevennaimark/devtoil/Ziptility/Bivvy/src/app/components/task-list-item/task-list-item.component.ts */
.container.selected input[type=checkbox] {
  opacity: 1;
}
.due-date-badge.pastDue {
  background-color: #ffe7e5;
  color: #FF442F;
  display: flex;
  gap: 0.25rem;
  align-items: center;
  border-radius: 0.375rem;
  padding: 0.25rem;
  margin: 0.25rem 0;
}
.due-date-badge.notDue,
.due-date-badge.dueToday {
  background-color: #e7e9ea;
  color: #6b7280;
  display: flex;
  gap: 0.25rem;
  align-items: center;
  border-radius: 0.375rem;
  padding: 0.25rem;
  margin: 0.25rem;
}
/*# sourceMappingURL=task-list-item.component.css.map */
